/// <reference types="node" />
export var version = "8.5.0";